/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsTextSize } from '../SdsText';
import { DividerTextAlignment } from './Divider.types';

/**
 * The props for `<Divider />`.
 */
export interface DividerProps {
  /**
   * The optional text to display.
   */
  text?: string;

  /**
   * The alignment of the text.
   */
  textAlignment?: DividerTextAlignment;

  /**
   * The size of the text.
   */
  textSize?: SdsTextSize;
}

/**
 * The default prop values for `<Divider />`.
 */
export const DividerDefaults: DividerProps = {
  textAlignment: DividerTextAlignment.Center,
  textSize: SdsTextSize.Small,
};
